import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mondo-esoterico',
  templateUrl: './mondo-esoterico.component.html',
  styleUrls: ['./mondo-esoterico.component.scss']
})
export class MondoEsotericoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
